import * as types from './types';

export const createFetchData = (query) => ({
  type: types.FETCH_DATA,
  query,
});

export const createFetching = (query) => ({
  type: types.FETCHING,
  query,
});

export const createFetchingSuccess = (response) => ({
  type: types.FETCHING_SUCCESS,
  response,
});

export const createFetchingFail = (errorCode, errorMsg) => ({
  type: types.FETCHING_FAIL,
  errorCode,
  errorMsg,
});
